<template>
    <div>
        <v-row align="center" justify="center">
            <v-col cols="12" lg="8" md="8" sm="8">
                <v-card class="card-shadow" v-if="show_additional_slogan || slogan" elevation="0">
                    <v-card-text class="headline text-center mb-2">
                        <div
                            style="padding: 8px 45px; color: #292929;"
                            v-html="slogan ? slogan : $t('get_now')"
                        ></div>
                    </v-card-text>
                </v-card>
                <v-card class="mt-6">
                    <v-app-bar
                        v-show="show_i_need"
                        color="grey lighten-3"
                        elevation="0"
                        :height="show_slider ? 130 : 60"
                    >
                        <v-row v-if="show_slider" align="center" justify="center">
                            <v-col cols="12">
                                <div class="subtitle-1 font-weight-bold text-center">
                                    {{ $t("choose_loan_value") }}
                                    <span class="title font-weight-bold">{{
                                        loanValue > 0 ? loanValue : 1000
                                    }}</span
                                    >{{ $t("currency_symbol") }}
                                </div>
                            </v-col>
                            <v-col cols="12" class="mb-5">
                                <vue-slider
                                    v-model="loanValue"
                                    :min="min"
                                    :max="max"
                                    :interval="step"
                                    :tooltip="'always'"
                                    :tooltip-formatter="formatter"
                                    :tooltip-placement="'bottom'"
                                    :style="cssValues"
                                ></vue-slider>
                            </v-col>
                        </v-row>
                        <v-row v-else align="center" justify="center">
                            <v-col cols="12">
                                <div class="subtitle-1 font-weight-bold text-center">
                                    {{ $t("i_need") }}
                                    <span class="title font-weight-bold">{{ loanValue }}</span
                                    >{{ $t("currency_symbol") }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-app-bar>

                    <v-progress-linear
                        :value="loanPossibility"
                        height="40"
                        striped
                        color="deep-orange accent-2"
                    >
                        <span class="subtitle-2 font-weight-bold">{{
                            $t("approvement_chance", { loanPossibility })
                        }}</span>
                    </v-progress-linear>

                    <slot></slot>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import settings from "@/environment";
import VueSlider from "vue-slider-component";

export default {
    name: "RegistrationLayout",
    components: {
        VueSlider,
    },
    props: ["loanPossibility", "slogan"],
    data() {
        return {
            show_i_need: settings.show_i_need,
            show_slider: settings.show_slider,
            min: settings.min_default_loanvalue,
            max: settings.max_default_loanvalue,
            step: settings.step,
            show_additional_slogan: settings.show_additional_slogan,
            formatter: (v) => {
                if (this.loanValue == 0) {
                    return "1000" + this.$t("currency_symbol");
                } else {
                    return (
                        `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` +
                        this.$t("currency_symbol")
                    );
                }
            },
        };
    },
    computed: {
        loanValue: {
            get() {
                return this.$store.getters.LOAN_VALUE;
            },
            set(value) {
                this.$store.dispatch("SET_LOAN_VALUE", value);
            },
        },
        startPossibility() {
            return this.$store.getters.START_LOAN_POSSIBILITY;
        },
        cssValues() {
            return {
                "--color": settings.primary_color,
            };
        },
    },
};
</script>

<style lang="scss">
$themeColor: var(--color);
@import "~vue-slider-component/lib/theme/default.scss";
</style>
